import { supabase } from './supabaseClient';
import { t } from './i18n';

// Invitatia unui om se face pe server, prin functia `invita-cont` (9 octombrie 2026). Pana atunci
// cele trei drumuri („+ Client nou", „Echipa", „Invita contul clientului") faceau contul din
// browser, cu `signUp`, ceea ce tinea inscrierea deschisa oricui pe server. Functia face contul,
// profilul si legatura cu clientul intr-un singur pas si o poate chema doar super adminul.
//
// Intoarce `{ ok: true }` sau `{ ok: false, cod, mesaj }`, cu `mesaj` gata de aratat omului.
export async function invitaCont({ email, nume, rol, clientId = null }) {
  let cod = '';
  let detaliu = '';
  try {
    const { data, error } = await supabase.functions.invoke('invita-cont', {
      body: { email, nume, rol, client_id: clientId },
    });
    if (!error && data && data.ok) return { ok: true, userId: data.user_id };
    if (error) {
      let corp = null;
      try { corp = await error.context.json(); } catch (e) { /* fara corp */ }
      cod = (corp && corp.error) || 'eroare';
      detaliu = (corp && corp.detail) || error.message || '';
    } else {
      cod = (data && data.error) || 'eroare';
      detaliu = (data && data.detail) || '';
    }
  } catch (e) {
    cod = 'eroare';
    detaliu = String(e && e.message ? e.message : e);
  }
  const mesaj = cod === 'adresa_folosita'
    ? t('clienti', 'invitaAdresaFolosita')
    : cod === 'client_are_cont'
      ? t('clienti', 'invitaClientAreCont')
      : t('clienti', 'eroareCont') + (detaliu || cod);
  return { ok: false, cod, mesaj };
}
